
import React, { useEffect } from "react";
import { CampLocation } from "@/types/campLocation";
import { UserInvitation } from "@/types/userInvitation";
import { SessionsTab } from "@/components/admin/locations/components/calendar/SessionsTab";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertTriangle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

interface WelcomeSessionsTabProps {
  location: CampLocation;
  invitation: UserInvitation;
}

const WelcomeSessionsTab: React.FC<WelcomeSessionsTabProps> = ({
  location,
  invitation
}) => {
  const { isAdmin, currentUser } = useAuth();
  
  // Add debug logging for WelcomeSessionsTab
  useEffect(() => {
    console.log("[WelcomeSessionsTab] Rendering with:", { 
      locationId: location?.id,
      locationName: location?.name,
      isAdmin,
      currentUserId: currentUser?.uid
    });
  }, [location, isAdmin, currentUser]);
  
  if (!location || !location.id) {
    return (
      <Alert variant="destructive">
        <AlertTriangle className="h-4 w-4" />
        <AlertTitle>Error loading location data</AlertTitle>
        <AlertDescription>
          Unable to load session management. Please try refreshing the page.
        </AlertDescription>
      </Alert>
    );
  }
  
  return (
    <SessionsTab 
      location={location} 
      locationId={location.id} 
      isInvitedUser={!isAdmin} // Set to the opposite of isAdmin to correctly identify invited users
      isWelcomeScreen={true}
    />
  );
};

export default WelcomeSessionsTab;
